























































import { Component, Vue, Ref } from 'vue-property-decorator'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import BuilderAddButton from '@/components/builder/BuilderAddButton.vue'
import BuilderDefaultContainer from '@/components/builder/BuilderDefaultContainer.vue'
import BuilderSidebar from '@/components/builder/BuilderSidebar.vue'
import BuilderButton from '@/components/builder/BuilderButton.vue'
import BuilderTooltip from '@/components/builder/BuilderTooltip.vue'
import StepsNavigation from './components/StepsNavigation.vue'
import AppExampleDialogEmpty from './components/AppExampleDialogEmpty.vue'
import CommonButton from '@/components/common/CommonButton.vue'
import CommonModal from '@/components/common/CommonModal.vue'
import i18n from '@/plugins/i18n'

@Component({
  components: {
    BuilderDefaultContainer,
    BuilderTooltip,
    BuilderButton,
    BuilderSidebar,
    AppExampleDialogEmpty,
    StepsNavigation,
    BuilderAddButton,
    CommonButton,
    CommonModal,
  },
  computed: {
    ...mapGetters('buildergpt', ['getCurrentStep', 'getApp']),
  },
  methods: {
    ...mapMutations('buildergpt', ['changeStep']),
    ...mapActions('buildergpt', ['saveData']),
  },
})
export default class BuilderGptStep3 extends Vue {
  @Ref('file') readonly fileInput!: HTMLInputElement
  getApp!: any
  loaded = true
  viewMode = false
  processing = false

  validationErrors = false
  open = false
  stepData: any = {
    emptyChatLogo: null,
    emptyChatMessage: '',
  }
  promoPageName = ''
  getCurrentStep!: number
  saveData!: any

  get position() {
    if (this.$breakpoints.desktop) {
      return 0
    }
    if (this.$breakpoints.tablet) {
      return 130
    }
    if (this.$breakpoints.mobileSmall) {
      return 15
    }
    if (this.$breakpoints.xs) {
      return 95
    }
    return 0
  }

  get isHasAvatar() {
    return !!this.stepData.emptyChatLogo
  }

  get avatarBlob(): string | null {
    if (!this.stepData.emptyChatLogo) {
      return ''
    }

    return this.stepData.emptyChatLogo instanceof Blob ? URL.createObjectURL(this.stepData.emptyChatLogo) : this.stepData.emptyChatLogo
  }

  onFileInputChange(files: File[]): void {
    const file = files[0]
    this.stepData.emptyChatLogo = file
  }

  onUploadPhotoClick(): void {
    if (!this.stepData.emptyChatLogo) {
      this.fileInput.click()
    } else {
      this.stepData.emptyChatLogo = null
    }
  }

  createFileFromUrl(url) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest()
      xhr.open('GET', url, true)
      xhr.responseType = 'blob'

      xhr.onload = function () {
        if (xhr.status === 200) {
          const file = new File([xhr.response], 'filename')
          resolve(file)
        } else {
          reject(new Error(`Ошибка при получении файла: ${xhr.status}`))
        }
      }

      xhr.onerror = function () {
        reject(new Error('Ошибка при получении файла.'))
      }

      xhr.send()
    })
  }
  async saveDefaultFile() {
    const url = require('@/assets/images/crm/png/chatgpt-avatar.png')
    return this.createFileFromUrl(url)
      .then((file) => {
        return file
      })
      .catch((error) => {
        console.error('Ошибка:', error)
      })
  }
  async confirmStep(): Promise<void> {
    if (!this.stepData.emptyChatLogo) {
      const file = await this.saveDefaultFile()
      this.stepData.emptyChatLogo = file
    }
    await this.saveData({ ...this.stepData, avatarBlob: this.avatarBlob })
    this.$router.push({ path: `/gpt/step/${this.getCurrentStep}` })
  }
  vModel(e) {
    this.stepData.emptyChatMessage = e.target.value
    this.adjustTextarea()
  }
  adjustTextarea() {
    const el: any = this.$refs.textarea
    el.style.height = 'auto'
    el.style.height = el.scrollHeight + 'px'
  }
  mounted() {
    if (this.getApp.emptyChatLogo) {
      this.stepData.emptyChatLogo = this.getApp.emptyChatLogo
    }
    if (this.getApp.emptyChatMessage) {
      this.stepData.emptyChatMessage = this.getApp.emptyChatMessage
    }
    this.adjustTextarea()
  }
}
